import { cx } from "../../lib/cx.js";
/* empty css          */
import { forwardRef } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
/**
* A status or label badge. With `onClick` it is a button (the clickable Rejected badge
* that opens the error report). The ref goes to the `<span>` or the `<button>`.
*/
var Badge = forwardRef(function Badge({ tone = "neutral", variant = "subtle", size = "md", dot = false, square = false, className, children, ...rest }, ref) {
	const classes = cx("ds-badge", `ds-badge--${tone}`, `ds-badge--${variant}`, `ds-badge--${size}`, square && "ds-badge--square", rest.onClick && "ds-badge--clickable", className);
	const content = /* @__PURE__ */ jsxs(Fragment$1, { children: [dot && /* @__PURE__ */ jsx("span", {
		className: "ds-badge__dot",
		"aria-hidden": "true"
	}), /* @__PURE__ */ jsx("span", {
		className: "ds-badge__label",
		children
	})] });
	if (rest.onClick) return /* @__PURE__ */ jsx("button", {
		ref,
		type: "button",
		className: classes,
		...rest,
		children: content
	});
	return /* @__PURE__ */ jsx("span", {
		ref,
		className: classes,
		...rest,
		children: content
	});
});
//#endregion
export { Badge };

//# sourceMappingURL=Badge.js.map